// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".userinfo{display:flex;flex-direction:column;align-items:center}.userinfo-avatar{width:64px;height:64px;margin:10px;border-radius:50%}userinfo-nickname{color:#aaa}", ""]);
// Exports
module.exports = exports;
